export default "__VITE_ASSET__DjDJCDPp__"